import React, { useEffect, useState } from "react";
import {
  NAME,
  IOS,
  ANDROID,
  CLIENT_PHONE,
  CLIENT_EMAIL,
  CLIENT_WEBSITE,
  CLIENT_ADDRESS1,
  CLIENT_ADDRESS2,
  CLIENT_ADDRESS3,
  CLIENT_ADDRESS4,
} from "../const";
import { sendConfirmationEmail } from "../components/FuncUtils";

export default function Mail() {
  const [data, setData] = useState(null);

  const qrLink = `${process.env.REACT_APP_API_URL}/qr?idFirebase=${data?.id}`;

  useEffect(() => {
    const stored = sessionStorage.getItem("userToMail");
    if (stored) {
      try {
        setData(JSON.parse(stored));
      } catch (e) {
        console.error("Erreur de parsing des données utilisateur :", e);
      }
    }
    //sessionStorage.removeItem("userToMail");
  }, []);

  const badgeLink = `${process.env.REACT_APP_API_URL}/generatePDF?format=A6portrait&idFirebase=${data?.id}`;
  const theEmailMailTo = "mailto:" + CLIENT_EMAIL;
  const theWebsiteHref = "https://" + CLIENT_WEBSITE;

  const theSubjectEn = "BAPP 2026 Networking Gift Show Confirmation";
  const theSubjectFr = "BAPP 2026 Networking Gift Show Confirmation";
  const theSubjectNl = "BAPP 2026 Networking Gift Show Bevestiging";

  const theContentEn = `<div>
  <p>
    Dear ${data?.firstname} ${data?.lastname},<br /><br />
    We are pleased to confirm that your registration for the event has been successfully received!<br /><br />
    You can now download the application dedicated to the event.<br /><br />
    This application allows you to:
  </p>

  <ul>
    <li>
      scan the QR code of an exhibitor or a visitor and add a comment to qualify the contact
    </li>
    <li>
      receive the list of exhibitors and visitors who have scanned you
    </li>
    <li>
      view the list of exhibitors as well as their booth locations
    </li>
  </ul>

  <p>
    <a href="${IOS}">Download the application for iOS</a><br /><br />
    <a href="${ANDROID}">Download the application for Android</a>
  </p>

  <p>
    Once the app is installed on your smartphone, identify yourself using your personal QR code below.
  </p>

  <p><img src="${qrLink}" alt="QR code" /></p>

   <p>
    Your badge is also available. You can download and print it, ideally on a 160 g/m² paper, to ensure its durability.
  </p>

  <p><a href="${badgeLink}" target="_blank">Download your badge</a></p>

  <p>Thank you for your interest, and we look forward to seeing you on 27/08 starting at 9:30 AM for the BAPP Networking Gift Show 2026!</p><br /><br />

  <p>
    ${NAME}<br />
    phone: ${CLIENT_PHONE}<br />
    email: <a href="${theEmailMailTo}">${CLIENT_EMAIL}</a><br />
    website: <a href="${theWebsiteHref}">${CLIENT_WEBSITE}</a><br />
    ${CLIENT_ADDRESS1}<br />
    ${CLIENT_ADDRESS2}<br />
    ${CLIENT_ADDRESS3}<br />
    ${CLIENT_ADDRESS4}<br />
  </p>
</div>
`;
  const theContentFr = `<div>
  <p>
    Chère/Cher ${data?.firstname} ${data?.lastname},<br /><br />
    Nous avons le plaisir de vous confirmer que votre inscription à l’événement
    est bien enregistrée !<br /><br />
    Vous pouvez dès à présent télécharger l'application dédiée à l'événement.<br /><br />
    Cette application vous permet de :
  </p>

  <ul>
    <li>
      scanner le QR code d'un exposant, ou d'un visiteur, et d'y ajouter un
      commentaire qualifiant le contact
    </li>
    <li>
      recevoir la liste des exposants et des visiteurs qui vous ont scanné
    </li>
    <li>visualiser la liste des exposants, ainsi que leur emplacement</li>
  </ul>

  <p>
    <a href="${IOS}">Télécharger l’application pour iOS</a><br /><br />
    <a href="${ANDROID}">Télécharger l’application pour Android</a>
  </p>

  <p>
    Une fois l'application installée sur votre smartphone, identifiez-vous grâce
    à votre QR code personnel ci-dessous.
  </p>

  <p><img src="${qrLink}" alt="QR code" /></p>

   <p>
  Votre badge est également disponible. Vous pouvez le télécharger et l’imprimer, idéalement sur un papier de 160 g/m², afin d’en garantir la durabilité.
</p>

<p><a href="${badgeLink}" target="_blank">Téléchargez votre badge</a></p>

  <p>Merci pour votre intérêt, et rendez-vous le 27/08 à partir de 9h30 pour le BAPP Networking Gift Show 2026 !</p><br /><br />

  <p>
    ${NAME}<br />
    téléphone : ${CLIENT_PHONE}<br />
    e-mail : <a href="${theEmailMailTo}">${CLIENT_EMAIL}</a><br />
    site web : <a href="${theWebsiteHref}">${CLIENT_WEBSITE}</a><br />
    ${CLIENT_ADDRESS1}<br />
    ${CLIENT_ADDRESS2}<br />
    ${CLIENT_ADDRESS3}<br />
    ${CLIENT_ADDRESS4}<br />
  </p>
</div>
`;

  const theContentNl = `<div>
  <p>
    Beste ${data?.firstname} ${data?.lastname},<br /><br />
    We bevestigen graag dat uw inschrijving voor het evenement succesvol is ontvangen!<br /><br />
    U kunt nu de app downloaden die speciaal voor het evenement is ontwikkeld.<br /><br />
    Deze applicatie stelt u in staat om:
  </p>

  <ul>
    <li>
      de QR-code van een exposant of bezoeker te scannen en er een kwalificerend commentaar aan toe te voegen
    </li>
    <li>
      de lijst te ontvangen van exposanten en bezoekers die u gescand hebben
    </li>
    <li>
      de lijst van exposanten en hun standlocaties te bekijken
    </li>
  </ul>

  <p>
    <a href="${IOS}">Download de app voor iOS</a><br /><br />
    <a href="${ANDROID}">Download de app voor Android</a>
  </p>

  <p>
    Zodra de app op uw smartphone is geïnstalleerd, kunt u zich identificeren met uw persoonlijke QR-code hieronder.
  </p>

  <p><img src="${qrLink}" alt="QR-code" /></p>

  <p>
  Je badge is ook beschikbaar. Je kunt het downloaden en afdrukken, bij voorkeur op papier van 160 g/m² om de duurzaamheid te garanderen.
</p>

<p><a href="${badgeLink}" target="_blank">Download je badge</a></p>


  <p>
    Hartelijk dank voor uw interesse en graag tot ziens op 27/08 vanaf 9u30 voor de BAPP Networking Gift Show 2026!
  </p><br /><br />

  <p>
    ${NAME}<br />
    telefoon: ${CLIENT_PHONE}<br />
    e-mail: <a href="${theEmailMailTo}">${CLIENT_EMAIL}</a><br />
    website: <a href="${theWebsiteHref}">${CLIENT_WEBSITE}</a><br />
    ${CLIENT_ADDRESS1}<br />
    ${CLIENT_ADDRESS2}<br />
    ${CLIENT_ADDRESS3}<br />
    ${CLIENT_ADDRESS4}<br />
  </p>
</div>
`;

  const theLocalisedSubject =
    data?.language === "fr"
      ? theSubjectFr
      : data?.language === "nl"
      ? theSubjectNl
      : theSubjectEn;

  const theLocalisedContent =
    data?.language === "fr"
      ? theContentFr
      : data?.language === "nl"
      ? theContentNl
      : theContentEn;

  const sendMail = async () => {
    const theEmail = await sendConfirmationEmail(
      data?.id,
      data?.firstname,
      data?.lastname,
      data?.email,
      data?.language
    );
    alert(theEmail);
  };

  if (!data) return <p>Chargement des données...</p>;
  //if (!clientName) return <p>Chargement des données...</p>;
  return (
    <div style={{ padding: "20px" }}>
      <p>data?.language {data?.language}/</p>
      <p>data?.id {data?.id}/</p>

      <p>from: info@bapp.be</p>
      <p>to: {data.email}</p>
      <p>replyTo: info@bapp.be</p>
      <h2>subject: {theLocalisedSubject}</h2>
      <div dangerouslySetInnerHTML={{ __html: theLocalisedContent }} />
      {theContentEn}
      <br />
      <br />
      {theContentFr}
      <br />
      <br />
      {theContentNl}
      <br />
      <br />
      <div>
        <button onClick={sendMail}>send the email</button>
      </div>
    </div>
  );
}
